'use client'

import { ReactNode } from 'react'

import { H3 } from '@/components/common/Typo'
import { TypoStyledContent } from '@/components/common/TypoStyledContent'

interface CustomTextProps {
  settings: {
    bodyText: string
    headingsText: string
  }
}

const CustomText = ({ settings }: CustomTextProps): ReactNode => {
  return (
    <div>
      <H3 className="mb-2 font-bold md:text-left">{settings.headingsText}</H3>
      <div className="text-center md:text-left">
        <TypoStyledContent
          className="text-center md:text-left"
          htmlContent={settings.bodyText}
        />
      </div>
    </div>
  )
}

export default CustomText
